import React, { useEffect } from 'react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}
export function Toast({
  message,
  isVisible,
  onClose
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  return <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[100] animate-slide-up" data-id="element-194">
      <div className="bg-luxury-espresso border border-luxury-gold/30 text-luxury-white px-6 py-3 rounded-full shadow-2xl text-sm font-medium flex items-center gap-3" data-id="element-195">
        <div className="w-2 h-2 rounded-full bg-luxury-gold" data-id="element-196" />
        {message}
      </div>
    </div>;
}